import React, { useEffect } from 'react';
import styles from './ProfileReminderModal.module.scss';

const ProfileReminderModal = ({ isOpen, onClose, onEditProfile }) => {

  if (!isOpen) return null;

  return (
    <div className={styles.reminderModalOverlay}>
      <div className={styles.reminderModal}>
        <h2>Welcome to Spin!</h2>
        <p>
          Hey there! We're excited to have you join our community. Taking a moment to complete your 
          profile will help us personalize your experience and connect you with others who 
          share your interests.
        </p>
        
        <div className={styles.buttonContainer}>
          <button 
            className={styles.editButton}
            onClick={onEditProfile}
          >
            Edit Profile
          </button>
          <button 
            className={styles.laterButton}
            onClick={onClose}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileReminderModal; 